import React, { useCallback, useEffect, useMemo } from 'react';
import useIsExchangeLoading from '../../hooks/use-exchange-loading.js';
import useFromAmount from '../../hooks/use-from-amount.js';
import usePrefilledAmountId from '../../hooks/use-prefilled-amount-id.js';
import { usePrefillsContext } from '../../context/prefills.js';
import useToSideLoading from '../../hooks/use-to-side-loading.js';
import useSwapMode from '../../hooks/use-swap-mode.js';
import useTrackAssetConfigureEvent from '../../hooks/analytics/use-track-configure-asset.js';
import { useLimitsContext } from '../../context/limits.js';
const PercentageSwitch = ({ Component, className, style, onPress, }) => {
    const [, setFromAmount] = useFromAmount();
    const { value: prefilledAmounts, loading: loadingPrefills } = usePrefillsContext();
    const [prefilledAmountId, setPrefilledAmountId] = usePrefilledAmountId();
    const isExchangeLoading = useIsExchangeLoading();
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const [, setSwapMode] = useSwapMode();
    const toSideLoading = useToSideLoading();
    const limits = useLimitsContext();
    const handlePress = useCallback((id) => {
        void trackAssetConfigureSwap();
        setSwapMode('ExactIn');
        setPrefilledAmountId(id);
        onPress?.(id);
    }, [onPress, setSwapMode, setPrefilledAmountId, trackAssetConfigureSwap]);
    const options = useMemo(() => {
        if (prefilledAmounts) {
            return Object.entries(prefilledAmounts).map(([id, { label }]) => ({ id, label }));
        }
        return [];
    }, [prefilledAmounts]);
    useEffect(() => {
        const prefilledValue = prefilledAmountId && prefilledAmounts?.[prefilledAmountId];
        if (prefilledValue?.value && !loadingPrefills) {
            setFromAmount(prefilledValue.value);
        }
    }, [prefilledAmountId, prefilledAmounts, loadingPrefills, setFromAmount]);
    const loading = toSideLoading || limits.loading || isExchangeLoading;
    if (Component) {
        return (React.createElement(Component, { onChange: handlePress, value: prefilledAmountId, loading: loading, options: options, className: className, style: style }));
    }
    return null;
};
export default PercentageSwitch;
